module.exports = __webpack_public_path__ + "TttUCfJ272GBgSKaOaD7KpBw1xU1rKptJj_0jans920.f9a1ec109534bcf5dce4.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/assets/fonts/font-google/TttUCfJ272GBgSKaOaD7KpBw1xU1rKptJj_0jans920.woff2
// module id = ../../../../../src/assets/fonts/font-google/TttUCfJ272GBgSKaOaD7KpBw1xU1rKptJj_0jans920.woff2
// module chunks = 40